<app-layout>
  <app-voltar route="listagem/estoque/relatorio-estoque" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>Ajuste de Movimentação</app-titulo>
    </div>
  </div>
  <div class="forms">
    <p *ngIf="produtoNome"><strong>Produto:</strong> {{ produtoNome }}</p>
    <p *ngIf="quantidadeAtual"><strong>Quantidade atual:</strong> {{ quantidadeAtual }}</p>
    <form [formGroup]="form">
      <div class="formList">
        <app-input type="number" label="Nova Quantidade" name="QT_MOVM_NOVA" formControlName="QT_MOVM_NOVA"
          [requiredInput]="true"></app-input>
        <app-input label="Motivo do Ajuste" name="TX_MOTV" formControlName="TX_MOTV" maxLength="500"
          [requiredInput]="true"></app-input>
      </div>
      <app-botao type="cadastro" class="botao-cadastro" text="Confirmar Ajuste" (click)="postarDados()"
        [disabled]="!form.valid"></app-botao>
    </form>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
